import dayjs from '@beunity/design/lib/dayjs_extend.js';

const userTimeZone = App.config.user?.timeZone;
const timeZone = userTimeZone || 'Europe/Zurich';

dayjs.tz.setDefault(timeZone);
